import React from 'react';
import { Dialog, Dialogs, Toast, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { UserSettings, GlobalState } from '@leverege/ui-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.layout.resetDialog');
function resetDialog(props) {
  const {
    show,
    onClose,
    onDelete
  } = props;
  const onDel = evt => {
    onClose(evt);
    onDelete(evt);
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    title: t('title'),
    okay: t('okay'),
    okayVariant: "primaryDestructive",
    onCancel: onClose,
    onOkay: onDel,
    children: /*#__PURE__*/_jsx(Text, {
      children: t('message')
    })
  });
}
export default {
  id: 'molten.layout.ResetLayoutAction',
  name: 'Reset',
  matches: {
    use: 'actionBar',
    client: 'LayoutEditor'
  },
  handles: context => {
    return true;
  },
  layout: {
    sort: 'zzzz.zzzz'
  },
  appearance: ({
    context
  }) => {
    const scope = UserSettings.getScope(GlobalState.get(), context?.clientProps?.settingsPath);
    return {
      name: t('name'),
      icon: tIcon('repeatIcon', 'fa fa-repeat fa-fw'),
      visible: scope === 'user'
    };
  },
  perform: ({
    context,
    onClose: closeParent
  }) => {
    const {
      onClose,
      clientProps
    } = context;
    const {
      settingsPath,
      actionCloseOnExec
    } = clientProps || {};
    const onDelete = async evt => {
      try {
        const scope = UserSettings.getScope(GlobalState.get(), settingsPath);
        if (scope === 'user') {
          await UserSettings.reset(settingsPath);
        }
        Toast.success([t('successTitle'), t('successMessage')]);
      } catch (err) {
        Toast.error([t('errorTitle'), t('errorMessage'), t('errorReason', {
          message: err.message
        })]);
      }
      if (onClose && actionCloseOnExec) onClose(evt);
    };
    if (closeParent) closeParent();
    Dialogs.show({
      component: resetDialog,
      props: {
        onDelete
      }
    });
  }
};